module.exports = __webpack_public_path__ + "assets/fa054542ac2da758e27ec9604cf71f1e.png";